     
    <footer class="section-padding bg-light-theme pt-0 u-line bg-white">
        <div class="u-line instagram-slider swiper-container">
            <ul class="hm-list hm-instagram swiper-wrapper">
                <li class="swiper-slide">
                    <a><img src="assets/img/restaurants/250x200/insta-3.webp"  alt="instagram"></a>
                </li>
                <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-1.webp" alt="instagram"></a>
                </li>
                <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-2.webp"  alt="instagram"></a>
                </li>
                <!-- <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-4.webp" alt="instagram"></a>
                </li> -->
                <!-- <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-5.webp" alt="instagram"></a>
                </li> -->
                <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-4.webp" alt="instagram"></a>
                </li>
                <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-5.webp" alt="instagram"></a>
                </li>
                <!-- <li class="swiper-slide">
                    <a ><img src="assets/img/restaurants/250x200/insta-7.webp" alt="instagram"></a>
                </li> -->
              
            </ul>
        </div>
        <div class="container">
            <div class="row">
                <!-- <div class="col-xl col-lg-0 col-md-0 col-sm-0">
                    <div class="footer-contact">
                      
                    </div>
                </div> -->
                <div class="col-xl col-lg-4 col-md-4 col-sm-6 mt-3">
                    <div class="" >
                        <!-- <h6 class="text-custom-white">Let Us Help You</h6> -->
                        <div class="logo mainNavCol">
                            <a routerLink="/">
                                <img src="assets/img/LA Burgers logo-1_page-0001.png" class="img-fluid logoImg"  alt="Logo">
                            </a>
                        </div>
                        <ul>
                            <li><a  class="text-light-black ">Suite 306, 111 Overton Rd,</a><br>
                               <a class="text-light-black "> Williams Landing VIC 3027</a>
                            </li>
                            <li class="fw-500"><span class="text-light-black">Call Us :</span> <a href="tel:" class="text-custom-black"> 08 8914 6796</a>
                            </li>
                            <li class="fw-500"><span class="text-light-black">Email Us :</span> <a href="mailto:" class="text-custom-black"> info@laburgersandshakes.com.au</a>
                            </li>
                           
                        </ul>
                    </div>
                </div>
                <div class="col-xl col-lg-4 col-md-4 col-sm-6">
                    <div class="footer-links">
                        <h5 class="text-custom-black">Get to Know Us</h5>
                        <ul>
                            <li><a routerLink="/" class="text-light-black fw-500">Home</a>
                            </li>
                            <li><a routerLink="/menu" class="text-light-black fw-500">Menu</a>
                            </li>
                            <li><a routerLink="/about" class="text-light-black fw-500">About Us</a>
                            </li>
                            <li><a routerLink="/news" class="text-light-black fw-500">News</a>
                            </li>
                            <li><a routerLink="/contact" class="text-light-black fw-500">Contact Us</a>
                            </li>
                        </ul>
                    </div>
                </div>
              
                <div class="col-xl col-lg-4 col-md-4 col-sm-6">
                    <div class="footer-links">
                        <h5 class="text-custom-black">Opening Hours</h5>
                        <ul>
                            <li><a  class="text-light-black ">Weekdays: 11:00am - 10:00pm</a>
                            </li>
                            <li><a  class="text-light-black ">Weekend: 11:00am - 10:00pm</a>
                            </li>
                         
                        </ul>
                    </div>
                </div>
                <!-- <div class="col-xl col-lg-4 col-md-4 col-sm-6">
                    <div class="footer-links">
                        <h6 class="text-custom-white">Download Apps</h6>
                        <div class="appimg">
                            <a >
                                <img src="assets/img/playstore.jpg" class="img-fluid" alt="app logo">
                            </a>
                        </div>
                        <div class="appimg">
                            <a >
                                <img src="assets/img/appstore.jpg" class="img-fluid" alt="app logo">
                            </a>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="col-xl col-lg-4 col-md-4 col-sm-6">
                    <div class="footer-contact">
                        <h6 class="text-custom-black">Need Help</h6>
                        <ul>
                           
                            <li class="fw-600"><span class="text-light-black">Join our twitter </span> <a  class="text-custom-black"> @quickmunch</a>
                            </li>
                         
                        </ul>
                       
                    </div>
                </div> -->
                <div class="col-md-12">
                    <div class="ft-social-media">
                        <h5 class="text-center text-light-black">Follow us</h5>
                        <ul>
                            <li> <a ><i class="fab fa-facebook-f"></i></a>
                            </li>
                            <!-- <li> <a ><i class="fab fa-twitter"></i></a>
                            </li> -->
                            <li> <a ><i class="fab fa-instagram"></i></a>
                            </li>
                            <!-- <li> <a ><i class="fab fa-pinterest-p"></i></a>
                            </li>
                            <li> <a ><i class="fab fa-youtube"></i></a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <div class="copyright bg-black">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-4">
                    <div class="payment-logo mb-md-20"> <span class="text-light-white fs-14 mr-3"></span>
                        <!-- <div class="payemt-icon">
                            <img src="assets/img/card-front.jpg" alt="#">
                            <img src="assets/img/visa.jpg" alt="#">
                            <img src="assets/img/amex-card-front.png" alt="#">
                            <img src="assets/img/mastercard.png" alt="#">
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4 text-center medewithlove align-self-center">
                </div>
                <div class="col-lg-4">
                    <div class="copyright-text"> <span class="text-light-white"> <a href="https://metropolitanhost.com/" class="text-light-white"> @</a> - {{ currentYear }}
                        LA Burgers. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer -->